import type { IntlShape } from "react-intl"
import { pricingFieldMessages } from "../hooks/pricingField.messages"
import type { JapanVehicleAndMiscPricingFields } from "./japanVehicleAndMiscPricing.fields"
import { japanVehicleAndMiscPricingFieldNames } from "./japanVehicleAndMiscPricing.fields"

export const getJapanVehicleAndMiscPricingFields = (
	isDraft: boolean,
	formatMessage: IntlShape["formatMessage"],
): JapanVehicleAndMiscPricingFields => {
	const priceField = {
		debounced: isDraft ? 500 : undefined,
		type: "currency",
	} as const
	return {
		automobileTax: {
			...priceField,
			label: formatMessage(pricingFieldMessages.automobileTaxLabel),
			name: japanVehicleAndMiscPricingFieldNames.automobileTaxName,
			required: true,
		},
		inspectionRegistration: {
			...priceField,
			label: formatMessage(pricingFieldMessages.inspectionRegistrationLabel),
			name: japanVehicleAndMiscPricingFieldNames.inspectionRegistrationName,
			required: true,
		},
		inspectionRegistrationAgencyFee: {
			...priceField,
			label: formatMessage(pricingFieldMessages.inspectionRegistrationAgencyFeeLabel),
			name: japanVehicleAndMiscPricingFieldNames.inspectionRegistrationAgencyFeeName,
			required: true,
		},
		liabilityInsurance: {
			...priceField,
			label: formatMessage(pricingFieldMessages.liabilityInsuranceLabel),
			name: japanVehicleAndMiscPricingFieldNames.liabilityInsuranceName,
			required: true,
		},
		lightVehicleTaxEnvironmentalPerformanceLevy: {
			...priceField,
			label: formatMessage(pricingFieldMessages.lightVehicleTaxEnvironmentalPerformanceLevyLabel),
			name: japanVehicleAndMiscPricingFieldNames.lightVehicleTaxEnvironmentalPerformanceLevyName,
			required: true,
		},
		minimumPrice: {
			...priceField,
			label: formatMessage(pricingFieldMessages.minimumPriceLabel),
			name: japanVehicleAndMiscPricingFieldNames.minimumPriceName,
		},
		parkingCertificate: {
			...priceField,
			label: formatMessage(pricingFieldMessages.parkingCertificateLabel),
			name: japanVehicleAndMiscPricingFieldNames.parkingCertificateName,
			required: true,
		},
		parkingCertificationAcquisitionAgencyFee: {
			...priceField,
			label: formatMessage(pricingFieldMessages.parkingCertificationAcquisitionAgencyFeeLabel),
			name: japanVehicleAndMiscPricingFieldNames.parkingCertificationAcquisitionAgencyFeeName,
			required: true,
		},
		purchasePrice: {
			...priceField,
			label: formatMessage(pricingFieldMessages.purchasePriceLabel),
			name: japanVehicleAndMiscPricingFieldNames.purchasePriceName,
		},
		recyclingFee: {
			...priceField,
			label: formatMessage(pricingFieldMessages.recyclingFeeLabel),
			name: japanVehicleAndMiscPricingFieldNames.recyclingFeeName,
			required: true,
		},
		tonnageTax: {
			...priceField,
			label: formatMessage(pricingFieldMessages.tonnageTaxLabel),
			name: japanVehicleAndMiscPricingFieldNames.tonnageTaxName,
			required: true,
		},
		vatDeductible: {
			label: formatMessage(pricingFieldMessages.vatDeductibleLabel),
			name: japanVehicleAndMiscPricingFieldNames.vatDeductibleName,
		},
		vehiclePrice: {
			...priceField,
			label: formatMessage(pricingFieldMessages.vehiclePriceLabel),
			name: japanVehicleAndMiscPricingFieldNames.vehiclePriceName,
			required: true,
		},
	}
}
